// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"587":"852d06a8","764":"7fed4606"}[chunkId] + ".chunk.css";
};